// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-footer{color:#fa9600}`, "",{"version":3,"sources":["webpack://./src/Components/ModalFooter/ModalFooter.style.scss"],"names":[],"mappings":"AAEA,cACC,aAHS","sourcesContent":["$primary: #FA9600;\n\n.modal-footer{\n color: $primary;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
